module.exports = __webpack_public_path__ + "static/media/LotusOrb.62f68d3c.png";